/**
 * The public API base URL as shown to users: code snippets, docs, marketing
 * copy. Deliberately separate from lib/api/config.ts, which is what the app's
 * own relay talks to (server-only, read at runtime). This one is client-safe
 * and inlined at BUILD time via NEXT_PUBLIC, so changing it means rebuilding,
 * i.e. a redeploy.
 *
 * Env-only, no hardcoded fallback: set NEXT_PUBLIC_API_BASE_URL in .env
 * (local dev) and .env.production (committed, ships with the image). A build
 * without it fails at prerender instead of shipping a blank URL.
 */
const fromEnv = process.env.NEXT_PUBLIC_API_BASE_URL;
if (!fromEnv) {
  throw new Error(
    "NEXT_PUBLIC_API_BASE_URL is not set. Define it in .env (local dev) and .env.production (shipped builds); see kb/operations.md.",
  );
}

export const PUBLIC_API_BASE_URL = fromEnv;

/** OpenAI-compatible surface root: what goes in an SDK's `baseURL`. */
export const PUBLIC_API_V1_URL = `${PUBLIC_API_BASE_URL}/v1`;

/** Scheme-less form for tight UI spots (window chrome, badges). */
export const PUBLIC_API_V1_HOST = PUBLIC_API_V1_URL.replace(/^https?:\/\//, "");
